import React from "react";
import {findDOMNode} from "react-dom";
import { FieldPopoverMenuProps } from "../../../dropdown/components/popover/popover-menu";
import Popover from "../../../../../gd-components/gd-popover/popover-v2";
import PopoverPosition from "../../../../../gd-components/gd-popover/popover-position";
import Votes from "../../../../../model2/voting/votes";
import UserIcon from "../../../../../gd-components/icons/user/user";
import User from "../../../../../model2/user/user";
import {SortDirection} from "../../../../../data-structures/sort";

export default function FieldVotes_Popover(props:FieldPopoverMenuProps) {

    const currentValue  = props.field.getViewValue(props.model)

    const votesCollection : Votes = Votes.initFromJson(currentValue)

    let users : User[] = _.map(votesCollection.votes, (vote, key) => {
        return gd.session.users.get(vote.userId)!
    })

    users = _.sortBy(users, 'name', SortDirection.ASC)

    return (
        <Popover position        = {new PopoverPosition({attachment: "top center", targetAttachment: "bottom center"})}
                 popoverClass     = "popover-add-reaction"
                 getTargetFunc    = {() => findDOMNode(props.parent)}
                 onClickOutside   = {() => {
                     props.parent.hidePopover()
                 }}>

            <div className="ui5-popover-menu min-w-100">
                {_.map(users, (user, key) => {
                        return (
                            <div key={key} className="option">
                                <UserIcon userId = {user.id}
                                          size   = "22"
                                          hint   = {false}/>
                                <div className="m-l-10">
                                    {user?.name}
                                </div>
                            </div>
                        )
                    }
                )}
            </div>

        </Popover>
    );
}
